module.exports = __webpack_public_path__ + "img/UNKNOWN.4c9ad49b.png";